import { Box, Button, ClickAwayListener, Grid, Grow, TextField, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';


export const PanelFormulario = ({onButtonClick, handleChange, formState, handleClick}) => {
    const classes = useStyles();
    const [collapsed, setCollapsed] = useState(true);
    const [sugerencia, setSugerencia] = useState(true);
    const [activo, setActivo] = useState('inactivo');


    

    const handleClickAway = ()=>{
        setCollapsed(true)
    }
    const handleToggle = ()=>{
        setCollapsed(!collapsed)
    }

    useEffect(() => {
        
      let mounted = true;
      if(mounted){
        if(!collapsed){
            setActivo('activado');
            setSugerencia(false);
        }
        
      }
        
    
      return () => {
        mounted = false;
      }
    }, [collapsed])

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
        <Box className={classes.contenedor}>
            <Box className={classes.toggleControl}>
                <Box  onClick={handleToggle} className={`${classes.botonPanel} shakeRotate ${activo}`}>
                    <Tooltip
                        // onClose={handleTooltipClose}
                        open={sugerencia}
                        placement="left"
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        title="¿Necesitas tinta?"
                        enterDelay={3000}
                        arrow
                    >
                        <img src={`${process.env.PUBLIC_URL}/images/pluma.png`}/> 
                    </Tooltip>
                </Box>
            </Box>
            <Grow in={!collapsed}>
                <Box className={classes.panelFormulario}>
                    <form className={classes.forulario}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <TextField 
                                    className={classes.campo}
                                    label="Título" 
                                    variant="outlined" 
                                    name="title" 
                                    onChange={handleChange}
                                    onClick={handleClick} 
                                    value={formState.title} />
                            </Grid>
                            <Grid item xs={12}>
                            <TextField
                                className={classes.campo}
                                label="Decreto"
                                name="description" 
                                multiline
                                maxRows={4}
                                onChange={handleChange}
                                onClick={handleClick} 
                                value={formState.description}
                                inputProps={{ maxLength: 1200 }}
                            />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField 
                                className={`${classes.campo} ${classes.signature}`}
                                label="Firma" 
                                variant="outlined" 
                                name="signature" 
                                onChange={handleChange}
                                onClick={handleClick} 
                                value={formState.signature} />
                            </Grid>
                        </Grid>
                    </form>
                    <Button 
                        className={classes.botonControl}
                        variant="contained" 
                        onClick={onButtonClick}
                    >
                        Descargar Decreto
                    </Button>
                    <Button 
                        className={classes.botonControl}
                        variant="contained" 
                        href="/constitucion-colombia-ninas-ninos/mi-pais/"
                    >
                        Volver
                    </Button>
                </Box>
            </Grow>
        </Box>
    </ClickAwayListener>
  )
}

const useStyles = makeStyles((theme) => ({
    panelFormulario: {
        position:'fixed',
        left:'0px',
        bottom:'0px',
        width:'100%',
        background:'#fff',
        boxShadow:theme.shadows[0],
        padding:'30px',
        
    },
    contenedor:{
        width:'100%',
        position:'absolute',
        left:'0px',
        bottom:'0px',
        
    },
    toggleControl:{
        position:'fixed',
        right:'5%',
        top:'5%',
    },
    botonPanel:{
        width:'70px',
        height:'70px',
        borderRadius:'50%!important',
        textAlign:'center',
        background: 'radial-gradient(circle, rgba(255,237,194,1) 0%, rgba(253,187,45,1) 100%)',
        position:'relative',
        transition:'all 0.5s ease-out',
        '& img':{
            width:'50px',
            lineHeight:'120px',
            position:'absolute',
            left:'50%',
            top:'50%',
            transform:'translate(-60%,-70%)',
        },
        '&:hover':{
            cursor:'pointer',
            transform:'scale(1.2) rotate(10deg)'
        }
    },
    botonControl:{
        margin:'5px 10px !important',
    },
    campo:{
        width:'100%'
    },
    forulario:{
        marginBottom:'20px'
    }
    
}))

export default PanelFormulario;